{
    "Profile_SupernovaCommercial_Employment.header": "Emploi",
    "Profile_SupernovaCommercial_Employment.employmentInformation": "Informations d'emploi",
    "Profile_SupernovaCommercial_Employment.jobTitle": "Titre du poste"
}
